export const localStorageKeys = {
  language: 'language',
  token: 'token',
  lastVisitedAuthPage: 'lastVisitedAuthPage',
  countryOfResidence: 'countryOfResidence',
  invoiceGeneratorRedirectLink: 'invoiceGeneratorRedirectLink',
};
